import { theDearestMillion } from "./agent-models.ts";
import { A_DOLLAR, moneySaid } from "./money.ts";
import type { BudgetPeriod } from "./period.ts";

export const THE_DEFAULT_CAP_IS_PER: BudgetPeriod = "day";

export const A_CONVERSATION_STARTS_CAPPED_AT = Math.round(theDearestMillion().dollars * A_DOLLAR);

export function whereTheDefaultCapComesFrom(): string {
  const dearest = theDearestMillion();
  const million = `a million tokens out of ${dearest.model} on ${dearest.provider}`;
  const source = `the dearest model Rally prices, read ${dearest.seen}`;
  return `${moneySaid(A_CONVERSATION_STARTS_CAPPED_AT)} a day: ${million}, ${source}`;
}
